import React, { Component } from "react";
import { connect } from "react-redux";
import { showModal } from "../../redux/actions/modalActions";
import { updatePriceAlert } from "../../redux/actions/priceAlertActions";
import { Icon } from "../icons/Icon";
import PriceAlertCardMobile from "./PriceAlertCardMobile";
import PriceAlertOptionsModal from "./priceAlertOptions/PriceAlertOptionsModal";

import variables from "../../styles/utils/variables.scss";
import UnlockPremiumModal from "../popups/UnlockPremiumModal";

interface Props {
  priceAlert: PriceAlert;
  updatePriceAlert: any;
  showModal: any;
  user?: UserState;
}

interface State {
  newAlertPrice: number;
}

class PriceAlertCard extends Component<Props, State> {
  state = {
    newAlertPrice: this.props.priceAlert.alert_price,
  };

  searchKeyStrokeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Allow empty field temporarily during editing
    const value = e.currentTarget.value;
    if (value === '') {
      this.setState({ newAlertPrice: '' as any });
    } else {
      // Convert to number if valid
      const numValue = parseFloat(value);
      if (!isNaN(numValue)) {
        this.setState({ newAlertPrice: numValue });
      }
    }
  };

  onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const characterCode = e.charCode || e.keyCode || e.key;
    // if user presses enter
    if (characterCode === 13) {
      // Validate before sending to ensure we have a valid number
      if (typeof this.state.newAlertPrice === 'string' && this.state.newAlertPrice === '') {
        // Default to 0 if empty
        this.setState({ newAlertPrice: 0 }, () => {
          this.props.updatePriceAlert(
            this.props.priceAlert.item.id,
            this.state.newAlertPrice
          );
        });
      } else {
        this.props.updatePriceAlert(
          this.props.priceAlert.item.id,
          this.state.newAlertPrice
        );
      }
    }
  };

  clickedOptions = (priceAlert: PriceAlert | undefined) => {
    if (priceAlert?.item.id === undefined) {
      return;
    }
    const button = document.getElementById(priceAlert.item.id.toString());

    if (button) {
      const postionOfButton = button.getBoundingClientRect();

      const modalContent = this.props.user?.isPremium
          ? () => (
              <div
                  style={{
                    marginTop: postionOfButton.bottom + 20 + "px", // fudge factor as the button size is not working?
                    marginLeft: postionOfButton.left - 40 + "px", // place content left and caret right
                    width: postionOfButton.right - postionOfButton.left + "px",
                  }}
              >
                <PriceAlertOptionsModal priceAlert={priceAlert} />
              </div>
          )
          : () => <UnlockPremiumModal />;
      this.props.showModal({ component: modalContent });
    }
  };

  // Find all vendors with prices below or equal to the alert price
  findAllMatchingVendors = (itemPricing: any[], alertPrice: number) => {
    if (!itemPricing || !itemPricing.length) return { matchedVendors: [] };
    
    // Find all vendors that have a price at or below the alert price
    const matchedVendors = itemPricing
      .filter(pricing => pricing.price <= alertPrice)
      .map(pricing => ({
        vendorId: pricing.vendor_id,
        vendor: pricing.vendor_id === 1 ? "Coles" : "Woolworths",
        price: pricing.price
      }));
    
    return { matchedVendors };
  };
  
  render() {
    const priceAlert = this.props.priceAlert;
    const isUserPremium = this.props.user?.isPremium;
    const violet = variables.violetColor;
    
    // Handle is_triggered property safely with type assertion to avoid TypeScript errors
    // This works because we know the API returns this property even if our type definition doesn't include it
    const is_triggered = (priceAlert as any)?.is_triggered || false;
    
    // Get all vendors with prices below or equal to the alert price
    let matchedVendors = [];
    if (is_triggered && priceAlert?.item?.item_pricing) {
      matchedVendors = this.findAllMatchingVendors(
        priceAlert.item.item_pricing,
        priceAlert.alert_price
      ).matchedVendors;
    }

    return (
        <>
          <div
              className={`u-hide--desktop ${!isUserPremium ? "u-opacity--5" : ""}`}
          >
            <PriceAlertCardMobile 
              priceAlert={priceAlert}
            />
          </div>
          <div className={`u-hide--mobile u-border--bottom--grey`}>
            <div className="u-ph--48 u-pt--12 u-flex u-justify-center">
              <div className="u-w-80pct">
                {/* Mini Dashboard Style Card */}
                <div style={{
                  borderRadius: '8px',
                  overflow: 'hidden',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                  marginBottom: '20px',
                  backgroundColor: 'white'
                }}>
                  {/* Header bar */}
                  <div style={{
                    padding: '14px 16px',
                    backgroundColor: '#f9f9f9',
                    borderBottom: '1px solid #eee',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center'
                    }}>
                      {is_triggered && matchedVendors.length > 0 && (
                        <div style={{
                          backgroundColor: '#9300DA',
                          color: 'white',
                          fontSize: '12px',
                          fontWeight: '500',
                          padding: '4px 10px',
                          borderRadius: '12px',
                          display: 'flex',
                          alignItems: 'center'
                        }}>
                          <span style={{
                            width: '6px',
                            height: '6px',
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            marginRight: '5px'
                          }}></span>
                          Price dropped
                        </div>
                      )}
                    </div>
                    
                    <div style={{ flex: 1 }}></div>
                  </div>
                  
                  {/* Content area */}
                  <div style={{
                    padding: '16px',
                    display: 'flex',
                    backgroundColor: 'white'
                  }}>
                    {/* Left: Item image */}
                    <div style={{
                      width: '80px',
                      marginRight: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <img 
                        src={priceAlert.item.image_url} 
                        alt={priceAlert.item.name}
                        style={{
                          maxWidth: '100%',
                          maxHeight: '80px',
                          objectFit: 'contain'
                        }}
                      />
                    </div>
                    
                    {/* Middle: Content area */}
                    <div style={{
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: matchedVendors.length === 0 ? 'center' : 'flex-start',
                      height: '80px'
                    }}>
                      {/* Product title */}
                      <div style={{
                        fontSize: '15px',
                        fontWeight: '600',
                        color: '#333',
                        marginBottom: matchedVendors.length > 0 ? '12px' : '0'
                      }}>
                        {priceAlert.item.name}
                      </div>
                      
                      {/* Vendor pricing */}
                      <div style={{
                        display: 'flex',
                        flexWrap: 'wrap'
                      }}>
                        {matchedVendors.map(vendor => (
                          <div key={vendor.vendorId} style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginRight: '16px',
                            marginBottom: '8px',
                            padding: '6px 12px',
                            backgroundColor: vendor.vendorId === 1 ? 'rgba(255, 0, 0, 0.08)' : 'rgba(130, 185, 49, 0.08)',
                            borderRadius: '6px'
                          }}>
                            <div style={{
                              width: '26px',
                              height: '26px',
                              borderRadius: '4px',
                              backgroundColor: vendor.vendorId === 1 ? '#ff0000' : '#82b931',
                              color: 'white',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontWeight: '600',
                              marginRight: '8px'
                            }}>
                              {vendor.vendorId === 1 ? 'C' : 'W'}
                            </div>
                            <div>
                              <div style={{fontSize: '12px', color: vendor.vendorId === 1 ? '#ff0000' : '#82b931'}}>Current price</div>
                              <div style={{fontWeight: '600'}}>${vendor.price.toFixed(2)}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    
                    {/* Right side with Alert Price and Options */}
                    <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                      marginLeft: '16px',
                      width: '120px'
                    }}>
                      {/* Alert Price moved to right side */}
                      <div style={{
                        backgroundColor: 'white',
                        padding: '8px 12px',
                        borderRadius: '6px',
                        marginBottom: '12px',
                        border: '1px solid #e0e0e0',
                        position: 'relative',
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
                      }}
                      title="Click to edit alert price"
                      onClick={() => {
                        const inputElement = document.getElementById('alertPriceInput-' + priceAlert.item.id);
                        if (inputElement) {
                          (inputElement as HTMLInputElement).focus();
                        }
                      }}>
                        {/* <div style={{fontSize: '12px', color: '#666', textAlign: 'center'}}>Alert Price</div> */}
                        <div style={{fontSize: '16px', fontWeight: '600', textAlign: 'center', position: 'relative', display: 'flex', justifyContent: 'center'}}>
                          <div style={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            backgroundColor: 'white',
                            padding: '4px 8px'
                          }}>
                            <span style={{ color: '#333' }}>$</span>
                            <input
                              id={`alertPriceInput-${priceAlert.item.id}`}
                              style={{
                                border: 'none',
                                background: 'transparent',
                                fontSize: '16px',
                                fontWeight: '600',
                                width: '60px',
                                padding: '4px',
                                outline: 'none',
                                textAlign: 'center',
                                color: '#333',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease'
                              }}
                              onMouseOver={(e) => {
                                e.currentTarget.style.color = '#9300DA';
                              }}
                              onMouseOut={(e) => {
                                e.currentTarget.style.color = '#333';
                              }}
                              onFocus={(e) => {
                                e.currentTarget.style.color = '#9300DA';
                              }}
                              onBlur={(e) => {
                                e.currentTarget.style.color = '#333';
                                this.props.updatePriceAlert(
                                  priceAlert.item.id,
                                  this.state.newAlertPrice
                                );
                              }}
                              value={
                                typeof this.state.newAlertPrice === "string"
                                  ? this.state.newAlertPrice
                                  : this.state.newAlertPrice.toFixed(2)
                              }
                              type="text"
                              inputMode="decimal"
                              onChange={this.searchKeyStrokeChange}
                              onKeyDown={this.onKeyPress}
                            />
                          </div>
                        </div>
                      </div>
                      
                      {/* Options button */}
                      <button
                        id={priceAlert.item.id?.toString()}
                        onClick={() => this.clickedOptions(priceAlert)}
                        style={{
                          border: '1px solid #ddd',
                          backgroundColor: 'white',
                          color: '#666',
                          borderRadius: '6px',
                          padding: '8px 16px',
                          fontWeight: '500',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        Options
                        <Icon
                          id="chevron_right"
                          size="m"
                          stroke={violet}
                          fill="none"
                          className="u-rotate--negative90deg u-ml--4"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
    );
  }
}

const mapStateToProps = (state: ReduxState) => ({
  user: state.user,
});

export default connect(mapStateToProps, {updatePriceAlert, showModal})(
    PriceAlertCard
);
